import React, { createContext, useContext, ReactNode } from "react";
import { useRestaurant } from "@/hooks/useRestaurant";
import type { Tables } from "@/integrations/supabase/types";

type Restaurant = Tables<"restaurants">;

interface RestaurantContextType {
  restaurants: Restaurant[];
  activeRestaurant: Restaurant | null;
  setActiveRestaurant: (restaurant: Restaurant) => void;
  isLoading: boolean;
  needsOnboarding: boolean;
  isOfflineMode: boolean;
  refetch: () => Promise<void>;
}

const RestaurantContext = createContext<RestaurantContextType | undefined>(undefined);

export function RestaurantProvider({ children }: { children: ReactNode }) {
  const restaurantState = useRestaurant();

  return (
    <RestaurantContext.Provider value={restaurantState}>
      {children}
    </RestaurantContext.Provider>
  );
}

export function useRestaurantContext() {
  const context = useContext(RestaurantContext);
  if (context === undefined) {
    throw new Error("useRestaurantContext must be used within a RestaurantProvider");
  }
  return context;
}
